import type { FC, ReactNode } from 'react'
import { cn } from '../utils/cn'

export const Title: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => <h2 className={cn('[grid-area:title] flex items-center m-0', className)}>{children}</h2>

export const Body: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => (
  <div className={cn('[grid-area:body] pt-1 overflow-auto w-full max-h-150 min-w-136', className)}>{children}</div>
)

export const Actions: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => <div className={cn('[grid-area:actions] flex justify-end gap-6', className)}>{children}</div>

export const ModalLayout = {
  Title,
  Body,
  Actions,
}
